import api from './api';
import { criarNotificacaoCampanhaParaEstudantes } from './notificacaoService';

// Função para listar todas as campanhas
export const listarCampanhas = async (params = {}) => {
  try {
    const { page = 1, limit = 10, search = '', status = '' } = params;
    const response = await api.get('/campanhas', {
      params: {
        page,
        limit,
        search,
        status
      }
    });
    console.log('Resposta da API em listarCampanhas:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao listar campanhas:', error);
    throw error;
  }
};

// Função para obter uma campanha específica
export const obterCampanha = async (id) => {
  try {
    const response = await api.get(`/campanhas/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao obter campanha:', error);
    throw error;
  }
};

// Função para criar uma nova campanha
export const criarCampanha = async (campanhaData) => {
  try {
    const response = await api.post('/campanhas', {
      ...campanhaData,
      status: 'ativa'  // Define o status inicial como ativa
    });
    const novaCampanha = response.data;

    // Buscar o nome da instituição
    const instituicaoResponse = await api.get(`/instituicoes/${campanhaData.instituicaoId}`);
    const nomeInstituicao = instituicaoResponse.data.nome;

    // Criar notificações para os estudantes
    await criarNotificacaoCampanhaParaEstudantes({
      nomeCampanha: campanhaData.nome,
      nomeInstituicao,
      campanhaId: novaCampanha.id
    });

    return novaCampanha;
  } catch (error) {
    console.error('Erro ao criar campanha:', error);
    throw error;
  }
};

// Função para atualizar uma campanha
export const atualizarCampanha = async (id, campanhaData) => {
  try {
    const response = await api.put(`/campanhas/${id}`, campanhaData);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar campanha:', error);
    throw error;
  }
};

// Função para excluir uma campanha
export const excluirCampanha = async (id) => {
  try {
    const response = await api.delete(`/campanhas/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao excluir campanha:', error);
    throw error;
  }
};

// Função para listar campanhas por instituição
export const listarCampanhasPorInstituicao = async (instituicaoId, params = {}) => {
  try {
    const { page = 1, limit = 10, search = '', status = '' } = params;
    const response = await api.get(`/campanhas/instituicao/${instituicaoId}`, {
      params: {
        page,
        limit,
        search,
        status
      }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao listar campanhas por instituição:', error);
    throw error;
  }
};

// Função para listar campanhas ativas
export const listarCampanhasAtivas = async (params = {}) => {
  try {
    const { page = 1, limit = 10, search = '' } = params;
    const response = await api.get('/campanhas/ativas', {
      params: {
        page,
        limit,
        search
      }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao listar campanhas ativas:', error);
    throw error;
  }
};

// Função para buscar campanhas com filtros
export const buscarCampanhas = async (filtros = {}) => {
  try {
    const response = await api.get('/campanhas/buscar', { 
      params: {
        ...filtros,
        page: filtros.page || 1,
        limit: filtros.limit || 10
      }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar campanhas:', error);
    throw error;
  }
};

// Função para obter estatísticas de uma campanha
export const obterEstatisticasCampanha = async (id) => {
  try {
    const response = await api.get(`/campanhas/${id}/estatisticas`);
    return response.data;
  } catch (error) {
    console.error('Erro ao obter estatísticas da campanha:', error);
    throw error;
  }
};

// Função para alterar o status de uma campanha
export const alterarStatusCampanha = async (id, status) => {
  try {
    const response = await api.patch(`/campanhas/${id}/status`, { status });
    return response.data;
  } catch (error) {
    console.error('Erro ao alterar status da campanha:', error);
    throw error;
  }
};

// Função para duplicar uma campanha
export const duplicarCampanha = async (id) => {
  try {
    const response = await api.post(`/campanhas/${id}/duplicar`);
    return response.data;
  } catch (error) {
    console.error('Erro ao duplicar campanha:', error);
    throw error;
  }
};

// Função para obter inscrições de uma campanha
export const obterInscricoesCampanha = async (id, params = {}) => {
  try {
    const { page = 1, limit = 10, status = '' } = params;
    const response = await api.get(`/campanhas/${id}/inscricoes`, {
      params: {
        page,
        limit,
        status
      }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao obter inscrições da campanha:', error);
    throw error;
  }
};

// Objeto do serviço para exportação default
const campanhaService = {
  listarCampanhas,
  obterCampanha,
  criarCampanha,
  atualizarCampanha,
  excluirCampanha,
  listarCampanhasPorInstituicao,
  
  listarCampanhasAtivas,
  buscarCampanhas,
  obterEstatisticasCampanha,
  alterarStatusCampanha,
  duplicarCampanha,
  obterInscricoesCampanha
};

export default campanhaService;